export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./refuse-lead.vue?vue&type=template&id=d97706c8&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/refuse-lead.vue?vue&type=template&id=d97706c8&
// module id = 1387
// module chunks = 0